// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ud","image":"e_vd"};